import React from 'react';

function Footer() {
  return (
    <section className="min-h-fit flex flex-col justify-start pt-5 bg-slate-600 dark:bg-white items-center  px-5 text-center">
      <p className="max-w-xl font-light dark:text-gray-500 text-white mb-10">
        © 2023 AYODEJI ADEBOLU
      </p>
    </section>
  );
}

export default Footer;
